import * as Sentry from '@sentry/react'

export function getDSN() {
  const meta = document.head.querySelector('meta[name=sentry-dsn]')
  return meta?.content
}

export function getEnvironment() {
  const meta = document.head.querySelector('meta[name=sentry-environment]')
  return meta?.content
}

export function init() {
  const dsn = getDSN()

  if (dsn) {
    Sentry.init({
      dsn,
      environment: getEnvironment(),
    })
  }
}
